import { useState } from "react";

export default function FormCheckbox({ name, title, checked, onChange }) {
  function update(e) {
    onChange(name, e.target.checked);
  }

  return (
    <div className="w-80 flex items-center">
      <input
        id={`checkbox${name}`}
        type="checkbox"
        checked={checked}
        onChange={update}
        className="hidden"
      />

      <label
        htmlFor={`checkbox${name}`}
        className={`cursor-pointer px-[5px] text-sm rounded-md border select-none
          ${
            checked
              ? "border-green-700 bg-green-700 text-white"
              : "border-gray-700 bg-gray-800 text-gray-400"
          }
        `}
      >
        ✓
      </label>

      <label htmlFor={`checkbox${name}`} className="cursor-pointer pl-3 select-none">
        {title}
      </label>
    </div>
  );
}